class Player {
  constructor(props) {
    const frameWidth = 8;
    const frameHeight = 13;

    const aspectRatio = frameWidth / frameHeight;

    const speed = 0.5;

    Object.assign(this, {
      x: 0,
      y: 0,
      spriteName: 'beardmanBack',
      frameWidth,
      frameHeight,
      speed,
    }, props);

    this.frame = 1;

    this.width = this.height * aspectRatio;

    this.climbingDown = false;
  }

  flipRender(context) {
    // center on entity
    context.translate(this.x, this.y);

    // flip X
    context.scale(-1, 1);

    // undo center on entity
    context.translate(-this.x, -this.y);
  }

  update(scene) {
    if (this.climbingDown) {
      if (this.y + (this.height / 2) > scene.mainCanvas.height / 2) {
        this.climbingDown = false;
        this.frame = 0;

        setTimeout(() => {
          this.spriteName = 'beardman';

          setTimeout(() => {
            this.walkingToSwitch = true;
          }, 800);
        }, 300);

        return;
      }

      this.y += this.speed;

      this.toggle2Frames(1, 2);

      return;
    }

    if (this.climbingUpEnter) {
      if (this.y + (this.height / 2) < scene.mainCanvas.height / 2) {
        this.climbingUpEnter = false;
        this.frame = 0;

        setTimeout(() => {
          this.spriteName = 'beardman';

          setTimeout(() => {
            this.walkingToSwitch = true;
          }, 800);
        }, 300);

        return;
      }

      this.y -= this.speed;

      this.toggle2Frames(1, 2);

      return;
    }

    if (this.walkingToSwitch) {
      this.toggle2Frames(1, 2);

      this.x += this.speed;

      // reached switch
      if (this.x + (this.width / 2) > scene.mainCanvas.width / 2) {
        this.walkingToSwitch = false;
        this.frame = 0;

        // turn around
        setTimeout(() => {
          this.spriteName = 'beardmanBack';

          // hop to flip switch
          setTimeout(() => {
            this.y -= 5;

            setTimeout(() => {
              this.y += 5;
            }, 100);
          }, 400);

          // flip switch
          setTimeout(() => {
            scene.switchBox.frame = 0;

            document.body.classList.add('flicker-text');

            if (this.app && this.app.pipeScene) scene.app.pipeScene.pipeEnd.active = true;

            // start backing away
            setTimeout(() => {
              this.spriteName = 'beardman';

              this.edgeBackwards();
            }, 500);
          }, 500);
        }, 700);
      }

      return;
    }

    if (this.steppingBack) {
      this.x -= this.speed;

      this.toggle2Frames(1, 2);

      if (this.x < 0) {
        this.steppingBack = false;
        this.frame = 0;

        setTimeout(() => {
          this.spriteName = 'beardmanBack';

          if (scene.bottomEnter) {
            this.climbingDownExit = true;
          } else {
            this.climbingUp = true;
          }
        }, 200);
      }
    }

    if (this.climbingUp) {
      this.y -= this.speed;

      if (this.y + (this.height / 2) < -scene.mainCanvas.height / 2) {
        this.climbingUp = false;

        scene.inputDisabled = false;
      }

      this.toggle2Frames(1, 2);
    }

    if (this.climbingDownExit) {
      this.y += this.speed;

      if (this.y - (this.height / 2) > scene.mainCanvas.height / 2) {
        this.climbingDownExit = false;

        scene.inputDisabled = false;
      }

      this.toggle2Frames(1, 2);
    }
  }

  edgeBackwards() {
    setTimeout(() => {
      this.steppingBack = true;

      setTimeout(() => {
        this.frame = 0;
        this.steppingBack = false;

        setTimeout(() => {
          this.steppingBack = true;

          setTimeout(() => {
            this.frame = 0;
            this.steppingBack = false;

            setTimeout(() => {
              this.spriteName = 'beardman';
              this.flipped = true;
              this.steppingBack = true;
            }, 600);
          }, 500);
        }, 500);
      }, 500);
    }, 500);
  }

  toggle2Frames(frameA, frameB, toggleRate = 1) {
    if (Math.sin(new Date() / (100 * toggleRate)) > 0) {
      this.frame = frameA;
    } else {
      this.frame = frameB;
    }
  }

  render(canvas) {
    const { context } = canvas;

    context.save();

    if (this.flipped || this.spriteName === 'beardmanBack') this.flipRender(context);

    canvas.drawThing(this, this.frame);

    context.restore();
  }
}

export default Player;
